<template>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit }"
    slim
  >
    <form
      role="form"
      class="user form-horizontal"
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <fieldset>
        <!-- Name -->
        <Field
          :label="$t('WEBHOOKS_NAME')"
          :has-tooltip="true"
          :tooltip-text="$t('WEBHOOKS_NAME_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="incomingQueryStringName"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.name"
                    type="text"
                    :placeholder="$t('WEBHOOKS_NAME_DEFAULT')"
                    name="incomingQueryStringName"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        

        <!-- Call token -->
        <Field
          :label="$t('WEBHOOKS_CALL_ID')"
          :has-tooltip="true"
          :tooltip-text="$t('WEBHOOKS_CALL_ID_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="callToken"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.incomingCallIdQueryStringParameter"
                    :placeholder="$t('WEBHOOKS_CALL_ID_DEFAULT')"
                    type="text"
                    name="incomingCallIdQueryStringParameter"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>

        <!-- Revenue Token -->
        <Field
          :label="$t('WEBHOOKS_REVENUE')"
          :has-tooltip="true"
          :tooltip-text="$t('WEBHOOKS_REVENUE_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="revenueToken"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.conversionAmountQueryStringParameter"
                    type="text"
                    :placeholder="$t('WEBHOOKS_REVENUE_DEFAULT')"
                    name="conversionAmountQueryStringParameter"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>


        <!-- Fire Conversion -->
        <Field
          :label="$t('WEBHOOKS_FIRE_PIXEL')"
          :has-tooltip="true"
          :tooltip-text="$t('WEBHOOKS_FIRE_PIXEL_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="parameterTest"
              rules=""
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.conversionCriteriaParameterMatch"
                    :placeholder="$t('WEBHOOKS_FIRE_PIXEL_DEFAULT')"
                    type="text"
                    name="conversionCriteriaParameterMatch"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>
              </div>
            </ValidationProvider>
          </template>
        </Field>

        <div class="form-group">
          <div class="col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3">            
            <PrimaryButton
              size="sm"
              :show-loader-on-form="showLoader"
            >
              <span v-t="isNewWebhook ? 'CREATE' : 'UPDATE'" />
            </PrimaryButton>

            <button
              v-t="'CANCEL'"
              class="btn btn-sm btn-danger m-l-15"
              @click="cancel"
            />
          </div>
        </div>
      </fieldset>
    </form>
  </ValidationObserver>
</template>>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import PrimaryButton from '@/core/components/PrimaryButton';
import { _parseWebHook } from '@/angularBridgeCode/services/WebhookService';

export default {
  name: 'WebhookForm',
  components: { Field, PrimaryButton },
  props: {
    showLoader: {
      type: Boolean,
      default: () => true
    }, 
    currentWebhook: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isNewWebhook: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    innerValue: {
      conversionAmountQueryStringParameter:undefined,
      conversionCriteriaParameterMatch:undefined,
      id:undefined,
      incomingCallIdQueryStringParameter:undefined,
      name:undefined
    }
  }),
  computed: {
    webhook() { return _.cloneDeep(this.currentWebhook); },
    parsedWebhook() {
      return _parseWebHook(this.currentWebhook);
    },
  },
  beforeMount() {
    this.innerValue = {
      ...this.parsedWebhook
    };
  },
  methods:{
    onSubmit() {
      this.$emit('submit', this.innerValue);
    },
    cancel() {
      this.$emit('cancel', this.webhook);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
};
</script>